import {CustomTextField} from '../../../components/CustomTextField';
import {CustomSelect} from '../../../components/CustomSelect';
import {CustomDatePicker} from '../../../components/CustomDatePicker';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {gender} from '../../../enums/genderEnum';
import {useParams} from "react-router-dom";

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @param model modifiedData: model to data
 * @param event handleChange: event to update data
 */
const FieldsValidation = ({modifiedData, handleChange}) => {
    const { t } = useTranslation();
    const { guardFlowId } = useParams();

    const genderList = Object.entries(gender)
        .filter(([key]) => key !== '3')
        .map(([key, value]) => ({
            id: Number(key),
            name: t(value),
        }));
    return (
        <>
            <div className="d-flex flex-column gap-2">
                { guardFlowId ?
                    <>
                        <p className="fs-24-to-18 ibl-font-w-600 font-color-general-950">{t("thank_you_for_submitting_visitors_photo")}</p>
                        <p className="fs-20-to-14 ibl-font-w-400 font-color-general-950">{t("the_photo_has_been_submitted_successfully")}</p>
                    </>
                    :
                    <>
                        <p className="fs-24-to-18 ibl-font-w-600 font-color-general-950">{t("thank_you_for_submitting_your_photo")}</p>
                        <p className="fs-20-to-14 ibl-font-w-400 font-color-general-950">{t("if_you_find_any_errors_you_can_edit_the_details_otherwise_click_confirm_to_proceed")}</p>
                    </>
                }
            </div>
            <div className="row mt-2 py-0">
                <div className="col-12 col-md-12">
                    <CustomTextField
                        id={'txt_fv_name'}
                        name={'name'}
                        value={modifiedData.name}
                        trans={'name'}
                        type={'text'}
                        onChange={handleChange}
                    />
                </div>
                <div className="col-12 col-md-12">
                    <CustomTextField
                        id={'txt_fv_last_name'}
                        name={'lastName'}
                        value={modifiedData.lastName}
                        trans={'last_name'}
                        type={'text'}
                        onChange={handleChange}
                    />
                </div>
                <div className="col-12 col-md-12">
                    <CustomTextField
                        id={'txt_fv_second_last_name'}
                        name={'secondLastName'}
                        value={modifiedData.secondLastName}
                        trans={'second_last_name'}
                        type={'text'}
                        onChange={handleChange}
                    />
                </div>
                <div className="col-12 col-md-12">
                    <CustomSelect
                        id={'slt_fv_gender'}
                        name={'gender'}
                        value={modifiedData.gender}
                        key={modifiedData.gender}
                        keyName='id'
                        onChange={handleChange}
                        list={genderList}
                        trans={'gender'}
                        label={'lbl_s1d_genderId'}
                        showNoSelectionOption={false}
                    />
                </div>
                <div className="col-12 col-md-12">
                    <CustomDatePicker
                        id={'dp_fv_dob'}
                        name={'dob'}
                        onChange={(e) => {
                            handleChange({ target: { value: e, name: 'dob' } });
                        }}
                        trans={'dob'}
                        value={modifiedData.dob}
                        disableFuture={true}
                        openTo={'year'}
                    />
                </div>
            </div>
        </>
    );

}

export default FieldsValidation
